import { Outlet } from "react-router-dom";
import { withPartnersStore } from "./PartnersStore";

function Partners() {
    return (
        <Outlet />
    );
}

export default withPartnersStore(Partners);